module.exports = __webpack_public_path__ + "static/media/Bullet.00105ae7.svg";